import React, { useRef } from 'react';
import { useAgGridCommon } from 'common/table/agGrid/AgGridCommon';
import { AgGridReact } from 'ag-grid-react';
import { columnDefs } from '../columnDefs';
import clearingAccountsOpts from '../options';
import useDatasource from './useDatasource';
import useContext from '../useClearingAccountsContext';
import useOnCellClick from '../useOnCellClick';

export const MEMBER_USER_CLEARING_ACCOUNTS_GRID_NAME =
  'memberUserClearingAccounts';
const MEMBER_USER_CLEARING_ACCOUNTS_GRID_VERSION = 1;

const MemberUserClearingAccountsGrid = () => {
  const gridRef = useRef<AgGridReact>(null);

  const { gridVisible, initialGridSettings, onStateUpdated } = useAgGridCommon({
    gridName: MEMBER_USER_CLEARING_ACCOUNTS_GRID_NAME,
    version: MEMBER_USER_CLEARING_ACCOUNTS_GRID_VERSION,
  });

  const onCellClicked = useOnCellClick();
  const context = useContext();
  const datasource = useDatasource();

  return (
    <div className="ag-theme-quartz">
      {gridVisible ? (
        <AgGridReact
          ref={gridRef}
          columnDefs={columnDefs}
          gridOptions={clearingAccountsOpts}
          onStateUpdated={onStateUpdated}
          initialState={initialGridSettings}
          rowModelType="serverSide"
          serverSideDatasource={datasource}
          context={context}
          onCellClicked={onCellClicked}
        />
      ) : null}
    </div>
  );
};

export default MemberUserClearingAccountsGrid;
